"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectControls(_ref) {
  var check = _ref.check,
      uncheck = _ref.uncheck,
      selectControlsLabel = _ref.selectControlsLabel;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "select__controls"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: check
  }, selectControlsLabel.selectAll), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: uncheck
  }, selectControlsLabel.reset));
}

SelectControls.propTypes = {
  check: _propTypes.default.func,
  uncheck: _propTypes.default.func,
  selectControlsLabel: _propTypes.default.shape({
    selectAll: _propTypes.default.string,
    reset: _propTypes.default.string
  })
};
SelectControls.defaultProps = {
  check: function check() {},
  uncheck: function uncheck() {},
  selectControlsLabel: {
    selectAll: 'Select all',
    reset: 'Reset'
  }
};
var _default = SelectControls;
exports.default = _default;